import { Link } from "@inertiajs/react";
import { User, LogOut } from "lucide-react";
import { NavLink } from "./NavLink";

interface UserMenuProps {
  isActive: (path: string) => boolean;
}

export function UserMenu({ isActive }: UserMenuProps) {
  return (
    <div className="flex items-center gap-2">
      <NavLink href="/profile" active={isActive("/profile")}>
        <User size={16} />
        <span className="hidden sm:inline">Perfil</span>
      </NavLink>
      <Link
        href="/session"
        method="delete"
        as="button"
        className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-muted-foreground transition hover:bg-accent/10 hover:text-foreground"
      >
        <LogOut size={16} />
        <span className="hidden sm:inline">Sair</span>
      </Link>
    </div>
  );
}
